module.exports = __webpack_public_path__ + "img/photo-0046.c0487b74.jpg";